import { ActionCreator } from "redux";
import {
    ToggleAbleToSeeAndModifyExistingPatientDataOptionAction,
    ToggleAbleToSeeAndModifyExistingPreferredPharmacyOptionAction,
    ToggleRegionCodeConfirmationRequiredOptionAction,
    ToggleDisplayProfilePicturesDuringAppointmentConfirmationOptionAction,
    ToggleHealthCardExpirationRedirectToReceptionOptionAction,
    UpdateLanguageSelectionListAction,
    ChangeDefaultLanguageAction,
    ChangeAdminSettingNumberFieldAction,
    TogglePatientAbleToBookNewAppointmentAction,
    SelectCurrentSiteAction,
    ChangeAppointmentTimeRangeValueAction,
    UpdateSiteSelectionListAction
} from "./type";
import {
    CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO,
    CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY,
    CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT,
    CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE,
    CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION,
    UPDATE_LANGUAGE_SELECTION_LIST,
    CHANGE_DEFAULT_LANGUAGE,
    CHANGE_ADMIN_SETTING_NUMBER_FIELD,
    CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT,
    SELECT_CURRENT_SITE,
    CHANGE_APPOINTMENT_TIME_RANGE_VALUE,
    UPDATE_SITE_SELECTION_LIST
} from "./constant";
import { LanguageCodes } from "../../constants/languages";

/**
 * @name toggleAbleToSeeAndModifyExistingPatientDataState
 * @constructs ToggleAbleToSeeAndModifyExistingPatientDataStateAction
 * @param {boolean} value
 */
export const toggleAbleToSeeAndModifyExistingPatientDataOption: ActionCreator<
    ToggleAbleToSeeAndModifyExistingPatientDataOptionAction
> = (value: boolean) => ({
    type: CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO,
    payload: {
        value
    }
});

/**
 * @name toggleAbleToSeeAndModifyExistingPreferredPharmacyOption
 * @constructs ToggleAbleToSeeAndModifyPreferredPharmacyAction
 * @param {boolean} value
 */
export const toggleAbleToSeeAndModifyExistingPreferredPharmacyOption: ActionCreator<
    ToggleAbleToSeeAndModifyExistingPreferredPharmacyOptionAction
> = (value: boolean) => ({
    type: CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY,
    payload: {
        value
    }
});

/**
 * @name toggleRegionCodeConfirmationRequiredState
 * @constructs ToggleRegionCodeConfirmationRequiredStateAction
 * @param {boolean} value
 */
export const toggleRegionCodeConfirmationRequiredOption: ActionCreator<
    ToggleRegionCodeConfirmationRequiredOptionAction
> = (value: boolean) => ({
    type: CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT,
    payload: {
        value
    }
});

export const toggleDisplayProfilePicturesDuringAppointmentConfirmationOption: ActionCreator<
    ToggleDisplayProfilePicturesDuringAppointmentConfirmationOptionAction
> = (value: boolean) => ({
    type: CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE,
    payload: {
        value
    }
});

export const toggleHealthCardExpirationRedirectToReceptionOption: ActionCreator<
    ToggleHealthCardExpirationRedirectToReceptionOptionAction
> = (value: boolean) => ({
    type: CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION,
    payload: {
        value
    }
});

export const togglePatientAbleToBookNewAppointmentOption: ActionCreator<TogglePatientAbleToBookNewAppointmentAction> = (
    value: boolean
) => ({
    type: CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT,
    payload: {
        value
    }
});

export const updateLanguageSelectionList: ActionCreator<UpdateLanguageSelectionListAction> = (
    checked: true,
    languageCode: LanguageCodes
) => ({
    type: UPDATE_LANGUAGE_SELECTION_LIST,
    payload: {
        checked,
        languageCode
    }
});

export const changeDefaultLanguage: ActionCreator<ChangeDefaultLanguageAction> = (lang: LanguageCodes) => ({
    type: CHANGE_DEFAULT_LANGUAGE,
    payload: {
        lang
    }
});

export const changeAdminSettingNumberField: ActionCreator<ChangeAdminSettingNumberFieldAction> = (field: string, value: number) => ({
    type: CHANGE_ADMIN_SETTING_NUMBER_FIELD,
    payload: {
        field,
        value
    }
});

export const selectCurrentSite: ActionCreator<SelectCurrentSiteAction> = (selectedSiteId: string) => ({
    type: SELECT_CURRENT_SITE,
    payload: {
        selectedSiteId
    }
});

export const updateSiteSelectionList: ActionCreator<UpdateSiteSelectionListAction> = (
    checked: boolean,
    selectedSiteId: string | number
) => ({
    type: UPDATE_SITE_SELECTION_LIST,
    payload: {
        checked,
        selectedSiteId
    }
});

export const changeAppointmentTimeRangeValue: ActionCreator<ChangeAppointmentTimeRangeValueAction> = (
    boundField: string,
    value: number
) => ({
    type: CHANGE_APPOINTMENT_TIME_RANGE_VALUE,
    payload: {
        boundField,
        value
    }
})


// WEBPACK FOOTER //
// ./src/store/AdminOptions/actions.ts